<template>
  <div class="q-pa-sm q-pl-md">Layer Controls.  Additional layers that are related to this one or are of global interest (like bathy)
    <div v-for="(layerObj, name) in addlLayers" class="q-pa-xs">
      <q-toggle dense v-model="layerObj.visible" @update:model-value="changeLayerVis(layerObj)">{{  name }}</q-toggle>
    </div>
  </div>
</template>
<script setup>
// @ts-nocheck
import { toRefs, ref } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"

const { map } = useMapItems()
const { arrayFindObjectByProp } = useHelpers();
const emit = defineEmits(['changeLayerVis'])
const props = defineProps({})

const {  } = toRefs(props)

const addlLayers = ref({
  "Bathymetry" : {visible: true, layers: ['crcs-ne-bathy-1ovnsj', 'contour-line']},
  "Study Area" : {visible: true, layers: ['crcs-ne-studyarea-80mrer']},
  "Restricted Areas" : {visible: false, layers: ['restricted-areas', 'restricted-labels']},
  "Shipping Lanes" : {visible: false, layers: ['shipping', 'shipping-labels']},
  "Ecoregions" : {visible: true, layers: ['crcs-ne-eco-boundaries-cr1ok2', 'ecoregion-labels']}
})

const changeLayerVis = (layerObj) =>{
  // console.log(layerObj)
  layerObj.layers.forEach((lyrID) =>{
    // const layer = map.value.getLayer(lyrID);
    if (layerObj.visible){
      map.value.setLayoutProperty(lyrID, 'visibility', 'visible');
    }
    else{
      map.value.setLayoutProperty(lyrID, 'visibility', 'none');
    }
  })
  emit('changeLayerVis', addlLayers.value)
  
}
  
</script>